// extracted by mini-css-extract-plugin
export default {"question-answer-correct":"QuestionView_question-answer-correct__FpXSS","question-answer-wrong":"QuestionView_question-answer-wrong__I2CUc"};